









import Vue from 'vue';
import Plus from '@components/svg/plus.vue';

export enum IconType {
  PLUS = 'PLUS',
}

export default Vue.extend({
  name: 'Pill',
  props: {
    iconTypeVal: String,
    text: String,
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      switch (this.iconTypeVal) {
        case IconType.PLUS:
          return Plus;
        default:
          return '';
      }
    },
  },
});
